import React, { useRef } from "react";
import MonoButton from "../DesignKit/MonoButton";
import { FaYoutube, FaVimeo } from "react-icons/fa";
import RoughBorder from "./RoughBorder";

const platformIcons = {
  YouTube: FaYoutube,
  Vimeo: FaVimeo,
};

const VideoCard = ({ title, thumbnailUrl, mediaUrl, platform }) => {
  const PlatformIcon = platformIcons[platform] || null;
  const cardRef = useRef();

  return (
    <div className="relative">
      {/* Card-Box mit Ref */}
      <div
        ref={cardRef}
        className="relative border border-black rounded-xl p-4 bg-gradient-to-br from-orange-50/25 via-white to-orange-50  font-mono flex flex-col space-y-4 shadow-lg"
      >
        {/* Plattform-Icon als Badge oben links */}
        {PlatformIcon && (
          <div className="absolute -top-3 -left-3 transform -rotate-12 bg-white border border-black p-2 rounded-full shadow-md z-10">
            <PlatformIcon className="text-black w-6 h-6" />
          </div>
        )}
        <div className="left min-h-[3.5rem] flex items-start">
          <h2 className="text-xs sm:text-center lg:text-left font-light leading-tight">{title}</h2>
        </div>
        <div className="aspect-video overflow-hidden rounded-md border border-gray-300">
          <a href={mediaUrl} target="_blank" rel="noopener noreferrer">
            <img src={thumbnailUrl} alt={title} className="w-full h-full object-cover" />
          </a>
        </div>
        <MonoButton onClick={() => window.open(mediaUrl, "_blank")} className="w-full text-xs">
          Play
        </MonoButton>
      </div>
      {/* RoughBorder um die Card */}
      <RoughBorder
        parentRef={cardRef}
        radius={10}
        padding={2}
      color="#AC8E66" 
        strokeWidth={0.3}
        roughness={1}
        bowing={2}
      />
    </div>
  );
};

export default VideoCard;
